import crudActions from './crudActions';


export const { fetchSaleItems, createSaleItem, updateSaleItem, deleteSaleItem } = crudActions('saleItem');

